import { Button, Modal, ModalBody } from "flowbite-react";
import { useRef, useState } from "react";
import { TermsContent } from "./ModalTerms";

export function ModalContract({ isOpen, onClose }) {
  const [isExporting, setIsExporting] = useState(false);
  const contractRef = useRef(null);

  const handleExportPdf = async () => {
    if (!contractRef.current) return;

    setIsExporting(true);

    const termsScrollableContainer = contractRef.current.querySelector(
      "[data-terms-scroll-container]"
    );

    const previousMaxHeight = termsScrollableContainer?.style.maxHeight;
    const previousOverflowY = termsScrollableContainer?.style.overflowY;

    try {
      const { default: html2pdf } = await import("html2pdf.js");

      if (termsScrollableContainer) {
        termsScrollableContainer.style.maxHeight = "none";
        termsScrollableContainer.style.overflowY = "visible";
      }

      const options = {
        margin: [10, 10, 10, 10],
        filename: "termos-de-uso.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, logging: false },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"] },
      };

      await html2pdf().set(options).from(contractRef.current).save();
    } catch (error) {
      console.error("Erro ao exportar os termos em PDF:", error);
      alert("Nao foi possivel exportar o PDF. Tente novamente.");
    } finally {
      if (termsScrollableContainer) {
        termsScrollableContainer.style.maxHeight = previousMaxHeight || "";
        termsScrollableContainer.style.overflowY = previousOverflowY || "";
      }
      setIsExporting(false);
    }
  };

  return (
    <Modal show={isOpen} onClose={onClose} size="5xl">
      <ModalBody>
        <div ref={contractRef}>
          <TermsContent />
        </div>
      </ModalBody>
      <Modal.Footer className="flex justify-center pt-2 pb-3">
        <Button
          color="light"
          onClick={handleExportPdf}
          disabled={isExporting}
          isProcessing={isExporting}
        >
          Exportar PDF
        </Button>
        <Button onClick={onClose}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
}
